import styled from "styled-components";

import { EMPLOYEE_INFO_CHILDREN_SELECTION, TAGS } from "./constants";
import { getGroupType } from "../utils";
import { BUTTON_HEIGHT, FONT_SIZE, TEXT_SCALE_PROPS } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
export const Styles = styled.div<TEXT_SCALE_PROPS>`
  display: flex;
  flex-direction: column;
  padding-top: 0;
  position: relative;

  .item-box {
    padding: 0 !important;
  }
  .app-part-type {
    &.text,
    &.date,
    &.time,
    &.link,
    &.date_and_time,
    &.number,
    &.lookup {
      .item-box {
        .ant-input,
        .ant-picker {
          height: 44px;
        }
      }
    }
    &.lookup .ant-input { 
      border: unset;
      border-right: 1px solid #d9d9d9;
    }
    &.text_area {
      .ant-input {
        height: 100%;
      }
    }
    .rich_text {
      .item-box {
        height: 100%;
      }
      .quill {
        button {
          min-width: unset;
        }
        .ql-container {
          height: calc(100% - 20px);
          .ql-editor {
            background: #fff;
          }
        }
      }
    }
    &.related_records,
    &.created_datetime,
    &.updated_datetime,
    &.record_number,
    &.created_by,
    &.calculated,
    &.updated_by {
      .item-box {
        background: #fff;
        display: flex;
        align-items: center;
        height: 44px !important;
        div {
          padding-left: 10px;
        }
      }
    }
    &.attachment {
      .item-box {
        box-sizing: content-box;
        .attachment-container {
          padding: 0 !important;
          justify-content: center;
          height: 44px;
          .ant-upload.ant-upload-drag.ant-upload-disabled {
            border: unset !important;
            .ant-upload.ant-upload-disabled.ant-upload-btn {
              padding: 0;
            }
          }
        }
      }
    }
  }

  .app-part-type {
    &.dropdown {
      .ant-select {
        height: 100%;
        .ant-select-selector {
          height: 100%;
          padding-top: 4px;
        }
      }
    }

    overflow: hidden;
  }

  .division_selection,
  .worker_selection,
  .employee_info_selection,
  .branch_selection,
  .department_selection,
  .organization_selection {
    .item-box {
      max-height: 44px;
    }
    height: 100%;
    .ant-input-wrapper {
      height: 100%;
    }
    .ant-input {
      height: 100% !important;
    }
    button {
      height: 100%;
    }
  }

  .actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 10px;
    padding-top: 10px;
    height: 52px;
    border-bottom: none;
    background-color: #fff;

    .search-app-name {
      background-color: #fafcff;
      border-color: #71a5e4;
      height: 3rem;
      .ant-input {
        font-size: 1.3rem;
        padding: 0 1em;
      }
    }
    .button-lhd {
      padding: 6px 16px;
      margin-right: 12px;
      border: 1px solid rgba(37, 74, 127, 1);
      color: rgba(37, 74, 127, 1);
      background-color: #fff;
    }
    .btn-submit {
      padding: 6px 16px;
      margin-right: 12px;
      width: 110px;
      min-width: 110px;
    }
  }

  .wrap-button-add-column {
    position: absolute;
    top: ${({ text_scale }) =>
      text_scale === DISPLAY_SIZES.LARGE
        ? "-34px"
        : text_scale === DISPLAY_SIZES.MEDIUM
        ? "-27px"
        : "-21px"} !important;
    right: ${({ text_scale }) =>
      text_scale === DISPLAY_SIZES.LARGE
        ? "100px"
        : text_scale === DISPLAY_SIZES.MEDIUM
        ? "90px"
        : "85px"} !important;
        z-index: 100;
  }

  .table-drag-n-drop {
    // display: grid;
    // grid-template-columns: auto 1fr;

    .item {
      width: 100%;
      padding-right: 8px;

      .ant-select {
        width: 100%;
      }
    }
    // .react-grid-item {
    //   border: 1px solid transparent;
    // }

    .item2 {
      height: 100%;
      overflow: auto;
      scroll-behavior: smooth;
      background: #f7f9fa;
      .matching-react-grid-layout {
        &:has(.resizing) {
          .matching > .app-part-type{
              border: 1px solid #1890ff !important;
            }
          }
        }
      }
      .react-grid-layout {
        &:has(.matching-react-grid-layout) {
          .matching {
            border: 1px solid #1890ff;
            box-sizing: content-box;
          }
        }
        overflow: visible !important;
      }
    }

    .select-category-box {
      background-color: #fff;
    }

    .item2 {
      border: 1px solid #e7e7e7;
      padding: 8px;
      > .inner {
        height: 100%;
      }
      .react-grid-layout {
        overflow: auto;
        .app-part-wrapper {
          &.type-label {
            .item-box {
              border: none !important;
            }
          }
          .item-box {
            height: 100%;
            //border: 1px solid #c2c2c2;
            padding: 5px;
            overflow: hidden;
          }
          &.not-allow-view {
            background-color: #f2f2f2;

            &:hover {
              border: 1px solid #4fddfa;
            }
          }
          &.react-grid-item {
            box-sizing: border-box;
            &:hover {
              background-color: #f2f2f2;
            }
            .app-part-type {
              border: 1px solid #cccccc;
              &:hover {
                border: 1px solid #4fddfa;
              }
            }
            .react-resizable-handle {
              position: absolute;
              width: 10px;
              height: 10px;
              bottom: 0;
              right: 0;
              cursor: se-resize;
              z-index: 112121212;
            }
          }
        }
      }
    }
    .item1 {
      display: flex;
      flex-direction: column;
      background-color: #fff;
      z-index: 1;
      padding-top: 16px;
      border: none;
      border-top: 1px solid #e7e7e7;
      height: 100%;
      overflow-y: scroll;
      .name_group{
        font-weight: 700;
        padding: 6px 3px;
      }
      > div {
        -moz-user-select: -moz-none;
        -khtml-user-select: none;
        -webkit-user-select: none;
        -o-user-select: none;
        user-select: none;
      }
      .btn-drag {
        border-radius: 8px;
        color: #fff;
        font-weight: 800;
        background-color: #71a5e4;
        font-size: 0.8rem;
        padding: 0px 5px;
        cursor: all-scroll;
        cursor: -moz-all-scroll;
        cursor: -webkit-all-scroll;
        font-size: ${({ text_scale }) =>
          FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
        &.disabled {
          background-color: #c2c2c2;
          color: #000;
          cursor: default;
        }
      }
    }
  }

  .btn-back {
    background: #ffffff;
    border: 1px solid #174a83;
    color: #174a83;
    width: 100px;
    min-width: 100px;
  }

  .layoutJSON {
    background: #ddd;
    border: 1px solid black;
    margin-top: 10px;
    padding: 10px;
  }
  .columns {
    -moz-columns: 120px;
    -webkit-columns: 120px;
    columns: 120px;
  }

  .react-grid-item:not(.react-grid-placeholder) {
    background: transparent;
    color: #1890ff;
  }
  .react-grid-item.resizing {
    opacity: 0.9;
  }
  .react-grid-item.static {
    background: #cce;
  }
  .react-grid-item .minMax {
    font-size: 12px;
  }
  .react-grid-item .add {
    cursor: pointer;
  }
  .react-grid-dragHandleExample {
    cursor: move; /* fallback if grab cursor is unsupported */
    cursor: grab;
    cursor: -moz-grab;
    cursor: -webkit-grab;
  }
  .react-grid-layout {
    position: relative;
    transition: height 200ms ease;
  }
  .react-grid-item {
    transition: all 200ms ease;
    transition-property: left, top;
  }
  .react-grid-item.cssTransforms {
    transition-property: transform;
  }
  .react-grid-item.resizing {
    z-index: 1;
    min-height: 70px;
  }

  .react-grid-item.react-draggable-dragging {
    transition: none;
    z-index: 3;
  }

  .react-grid-item.react-grid-placeholder {
    background: #000;
    opacity: 0.1;
    transition-duration: 100ms;
    z-index: 2;
    border-radius: 4px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
  }

  .react-grid-layout.layout {
    min-height: 200 !important;
  }
  ul.ant-dropdown-menu {
    min-width: 52px;
    z-index: 9999999;
  }

  .disable {
    pointer-events: none;
  }

  .ant-upload {
    margin-right: 4px;

    button {
      height: 36px;
      border-radius: 2px;
      color: #666;
    }
  }

  .wrap-button-upload {
    border-radius: 2px;
    border: 1px solid #ccc;
    height: 36px;
    padding: 8px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .app-image {
    height: 36px;
    border: 1px solid #ccc;
    padding: 0 8px;
    border-radius: 2px;
    margin-right: 8px;

    img {
      width: 34px;
      height: 34px;
    }

    span {
      color: #1890ff;
      margin-left: 4px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .app-image-trash-icon {
      display: flex;
      height: 36px;
      justify-content: center;
      align-items: center;
      margin-left: 8px;
      cursor: pointer;
      color: #666;
    }
  }

  .type-table {
    .item-container {
      padding: 0;
    }
  }

  button {
    border-radius: 8px;
    height: 36px;
    min-width: 100px;
  }
  .item-container {
    min-width: 0;

    .check_box .is-horizontal {
      height: 44px;
    }

    .item_part_type_container {
      min-width: 0;
    }

    .ant-space {
      min-width: 0;
      width: 100%;
    }

  }

  .has-required-mark .ant-space-item {
    max-width: calc(100% - 10px);
  }
  .ant-space-item {
    div {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .item-box {
    border: 1px solid #ccc
  }

`;

export const WrapButton = styled.div`
  display: flex;
  margin-top: 16px;
  margin-bottom: 16px;

  .button-secondary {
    border: 1px solid rgba(37, 74, 127, 1);
    color: rgba(37, 74, 127, 1);
    background-color: #fff;
    margin-left: 12px;
    height: 34px;
  }
  .button-primary {
    height: 34px;
  }
`;

export const StylesTabPermission = styled.div<TEXT_SCALE_PROPS>`
  margin: 0 32px;
  position: relative;

  .wrap-no-data {
    border: 1px solid #bcbcbc;
    border-top: none;
    margin-left: 1px;
  }

  td,
  th {
    font-weight: 400;
    span {
      font-weight: 400;
    }
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 42px;

    h2 {
      font-size: 20px;
      font-weight: 600;
      color: #1e3666;
    }
  }

  .d-none {
    display: none;
  }
  .ant-select {
    min-width: 96%;

    .ant-select-arrow {
      right: 6px;
    }
  }
  .wrap-list-button {
    display: flex;
    position: absolute;
    right: 0;
    top: ${({ text_scale }) =>
      text_scale === DISPLAY_SIZES.SMALL
        ? "-21px"
        : text_scale === DISPLAY_SIZES.MEDIUM
        ? "-27px"
        : "-34px"};
    & button {
      margin-left: 12px;
      padding: 6px 16px;
      height: 36px;
    }
  }

  .ant-select-selection-item-content,
  .ant-select-selection-item {
    text-wrap: wrap;
    max-width: 60px;
  }

  .button-secondary {
    border: 1px solid rgba(37, 74, 127, 1);
    color: rgba(37, 74, 127, 1);
    background-color: #fff;
  }

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    padding: 0 4px;
  }
  .ant-select-single.ant-select-show-arrow .ant-select-selection-item {
    padding: 0;
  }

  .trash-icon {
    cursor: pointer;
  }

  .ant-tabs-nav {
    border-bottom: 1px solid #bcbcbc;
  }
  h4 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 0;
  }

  button {
    height: 36px;
  }
`;

export const StylesAppFormCreate = styled.div<TEXT_SCALE_PROPS>`
  position: relative;

  .wrap-button-save {
    position: absolute;
    top: -1px;
    right: -4px;
    z-index: 100;

    .btn-submit {
      height: 36px;
      min-width: 120px;
      width: 120px;
    }
  }
  .ant-tabs-top > .ant-tabs-nav {
    margin-left: 32px !important;
    margin-right: 32px !important;
  }
  .tab-custom .ant-tabs-tab .ant-tabs-tab-btn {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
  }
  .ant-tabs-tab .ant-tabs-tab-btn,
  .ant-tabs-tab {
    height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
  }
`;
const cssColorString = [...TAGS, ...EMPLOYEE_INFO_CHILDREN_SELECTION].reduce(
  (acc, cur) => {
    return (
      acc +
      `.item-container.${cur.app_part_type} ` +
      `{
      background: ${getGroupType(cur.group_type).bgColor};
      color: ${getGroupType(cur.group_type).color} 
    }`
    );
  },
  "",
);

export const StyledGird = styled.div`
  &.inner {
    width: 18001px;
    height: 1800px !important;
    background-size: 25px 25px;
    background-image: linear-gradient(to right, #e4e4e4 1px, transparent 1px),
      repeating-linear-gradient(to bottom, #e4e4e4 0 1px, transparent 1px 25px),
      repeating-linear-gradient(
        to bottom,
        transparent 0px 3.125px,
        #fff 3.125px 6.25px,
        transparent 6.25px 9.375px,
        #fff 9.375px 12.5px,
        transparent 12.5px 15.625px,
        #fff 15.625px 18.75px,
        transparent 18.75px 21.875px,
        #fff 21.875px 25px
      ),
      repeating-linear-gradient(
        to right,
        #e4e4e4 0 1px,
        white 1px 6.25px,
        rgb(207, 206, 206) 6.25px 7.25px,
        white 7.25px 13.25px,
        rgb(207, 206, 206) 13.25px 14.25px,
        white 14.25px 19.25px,
        rgb(207, 206, 206) 19.25px 20.25px,
        white 20.25px 25px
      );

    ${cssColorString}
  }
`;
